import { mesclarTrechos } from 'utils/buscaMenu';

// Campo de busca da barra lateral. Quem guarda o texto e filtra o menu é a
// BarraLateral; aqui ficam só o campo, o ícone e o botão de limpar.
function BuscaMenu({ valor, aoMudar, aoConfirmar }) {
	const aoTeclar = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			aoConfirmar();
		}

		if (e.key === 'Escape') {
			aoMudar('');
		}
	};

	return (
		<div className="menu-busca">
			<div className="menu-busca-campo">
				<i className="fa fa-search" aria-hidden="true" />
				<input
					type="search"
					value={valor}
					onChange={(e) => aoMudar(e.target.value)}
					onKeyDown={aoTeclar}
					placeholder="Buscar menu"
					aria-label="Buscar menu"
					autoComplete="off"
					spellCheck={false}
				/>
				{valor && (
					<button
						type="button"
						className="menu-busca-limpar"
						onClick={() => aoMudar('')}
						aria-label="Limpar busca"
						title="Limpar"
					>
						×
					</button>
				)}
			</div>
		</div>
	);
}

// Nome do menu com os trechos que bateram na busca marcados. `trechos` são índices
// [início, fim) no texto, como `filtrarMenus` devolve.
export function Destacado({ texto, trechos }) {
	if (!trechos || trechos.length === 0) {
		return texto;
	}

	const partes = [];
	let cursor = 0;

	mesclarTrechos(trechos).forEach(([inicio, fim], i) => {
		if (inicio > cursor) {
			partes.push(texto.slice(cursor, inicio));
		}
		partes.push(
			<mark key={i} className="menu-busca-destaque">{texto.slice(inicio, fim)}</mark>
		);
		cursor = fim;
	});

	if (cursor < texto.length) {
		partes.push(texto.slice(cursor));
	}

	return partes;
}

export default BuscaMenu;
